import { useState } from "react";
import SessionTimeoutProvider from "../../Context/sessionTimeoutProvider";
import { axiosInstance } from "../../axios/axiosInstance";
import { CHATBOT_API_DOC_HTML } from "./chatBotApiDoc";
import { CartPanel } from "./cartPanel";
import { OrderPanel } from "./orderPanel";
import { RecentPanel } from "./recentPanel";
import { RequestConsole } from "./requestConsole";
import styles from "./chatBotApiTest.module.css";

const TABS = [
  { key: "recent", label: "Recent Orders" },
  { key: "order", label: "Order Details" },
  { key: "cart", label: "Cart" },
  { key: "doc", label: "API Document" },
];

const ChatBotApiTestScreen = () => {
  const [tab, setTab] = useState("recent");
  const [results, setResults] = useState({ recent: null, order: null, cart: null });
  const [loading, setLoading] = useState(false);

  const callChatApi = async (key, url, params) => {
    setLoading(true);
    setResults((previous) => ({ ...previous, [key]: null }));
    try {
      var response = await axiosInstance.post(url, params);
      setResults((previous) => ({
        ...previous,
        [key]: { url, params, status: response?.status, data: response?.data },
      }));
    } catch (error) {
      setResults((previous) => ({
        ...previous,
        [key]: {
          url,
          params,
          status: error?.response?.status,
          data: error?.response?.data,
          error: error?.response ? "" : error?.message,
        },
      }));
    }
    setLoading(false);
  };

  const getRecentOrders = () => {
    callChatApi("recent", "Chat/OrderRecent", {});
  };

  const getOrderDetails = (orderId) => {
    callChatApi("order", "Chat/OrderDetails", { orderId: orderId });
  };

  const addToCart = (sku, qty) => {
    callChatApi("cart", "Chat/AddToCart", { sku: sku, qty: qty });
  };

  const fitDocFrame = (event) => {
    var frame = event.target;
    frame.style.height = frame.contentDocument.documentElement.scrollHeight + "px";
  };

  return (
    <div className={styles.page}>
      <header className={styles.header}>
        <div>
          <h1 className={styles.title}>ChatBot API Test</h1>
          <p className={styles.subtitle}>{window.location.origin}</p>
        </div>
        <nav className={styles.menu}>
          {TABS.map((item) => (
            <button
              key={item.key}
              type="button"
              className={item.key === tab ? `${styles.menuItem} ${styles.menuItemActive}` : styles.menuItem}
              onClick={() => setTab(item.key)}
            >
              {item.label}
            </button>
          ))}
        </nav>
      </header>

      {tab === "doc" ? (
        <section className={styles.docWrap}>
          <iframe title="ChatBot API Document" srcDoc={CHATBOT_API_DOC_HTML} className={styles.docFrame} onLoad={fitDocFrame} />
        </section>
      ) : (
        <div className={styles.body}>
          <section className={styles.panel}>
            {tab === "recent" && <RecentPanel loading={loading} onSubmit={getRecentOrders} />}
            {tab === "order" && <OrderPanel loading={loading} onSubmit={getOrderDetails} />}
            {tab === "cart" && <CartPanel loading={loading} onSubmit={addToCart} />}
          </section>

          <section className={styles.consoleWrap}>
            <RequestConsole result={results[tab]} loading={loading} />
          </section>
        </div>
      )}
    </div>
  );
};

export const ChatBotApiTest = () => (
  <SessionTimeoutProvider>
    <ChatBotApiTestScreen />
  </SessionTimeoutProvider>
);
